/* Keep floating shortcuts clear of the actual mobile purchase controls. */
(() => {
  const root = document.querySelector('.je-tour-root');
  if (!root || !('IntersectionObserver' in window)) return;
  const mobile = window.matchMedia('(max-width: 760px)');
  const targets = new Map();
  const selector = '#jeTourAddCart, #cta .sheet-open, #jeTourFallbackAddForm button[type="submit"]';
  function update() {
    let visible = false;
    targets.forEach((intersects, button) => {
      if (!button.isConnected) { targets.delete(button); observer.unobserve(button); }
      else if (intersects && !button.disabled) visible = true;
    });
    document.body.classList.toggle('je-purchase-focus', mobile.matches && visible);
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => targets.set(entry.target, entry.isIntersecting));
    update();
  }, { rootMargin: '-76px 0px -8px 0px', threshold: 0 });
  function bind() {
    root.querySelectorAll(selector).forEach(button => {
      if (!targets.has(button)) { targets.set(button, false); observer.observe(button); }
    });
    update();
  }
  let queued = false;
  const changes = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; bind(); });
  });
  changes.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  if (mobile.addEventListener) mobile.addEventListener('change', update);
  else mobile.addListener(update);
  bind();
})();

/* je-dead-taps-20261019: the hero cue on pages without the tour engine (the delivery page's
   "Check your postcode", the showroom's "Scroll") moves the page to the section under the
   hero, as the product pages' cue does (je-scrollcue-tap-20261013). One listener for the
   whole page; the engine's own one is skipped once this flag is set, and vice versa. */
(() => {
  if (window.__jeScrollCueTap) return;
  window.__jeScrollCueTap = 1;
  document.addEventListener('click', e => {
    try {
      const cue = e.target && e.target.closest ? e.target.closest('.scrollcue') : null;
      if (!cue) return;
      let node = cue.closest('header') || cue.parentNode, next = null;
      while (node && node !== document.body && !next) {
        next = node.nextElementSibling;
        while (next && !(next.offsetHeight > 0)) next = next.nextElementSibling;
        node = node.parentElement;
      }
      const calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (next && next.scrollIntoView) {
        try { next.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' }); }
        catch (err) { next.scrollIntoView(true); }
      } else {
        window.scrollBy(0, Math.round(window.innerHeight * 0.85));
      }
    } catch (err) {}
  });
  const style = document.createElement('style');
  style.textContent = '.scrollcue{cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent}';
  document.head.appendChild(style);
})();
